import { Palette } from "types/theme";

export const palette: Palette = {
  background: {
    base: '#E9E9E9',
    primary: '#FFFFFF',
    themeController: '#E9E9E9',
    themeControllerActive: '#FFFFFF',
    menuItemActive: '#E2E5FF',
    accent: '#6777FF',
    newReleaseCardsActive: '#F4F4F4',
    warning: '#EFFFF1',
  },
  text: {
    primary: '#000000',
    secondary: '#0B0B0B',
    label: '#939393',
    link: '#6777FF',
    breadcrumbs: '#7C7C7C',
    info: '#7C7C7C',
  },
  divider: {
    primary: '#DADADA',
  },
  icon: {
    primary: '#292D32',
    accent: '#6777FF',
  },
  border: {
    accent: '#6777FF',
    basic1: '#E9E9E9',
  },
  button: {
    primary: '#6777FF',
  },
  checkbox: {
    primary: '#6777FF',
  },
};
